import {
  MetricsNodeStatusCounts,
  MetricsNodeStatusCountsResponse,
} from "src/api/types";

type AggregatedCounts = {
  totalSuccess: number;
  totalFailed: number;
  totalIgnored: number;
  totalPending: number;
  totalOther: number;
  totalOutputMismatch: number;
};
export const aggregateStatusCounts = (
  statusCounts: Record<string, MetricsNodeStatusCounts>,
  outputNodeId: string,
): AggregatedCounts => {
  const totals = {
    // Output node has rows completing the entire flow.
    totalSuccess: statusCounts[outputNodeId]?.success ?? 0,
    totalOutputMismatch: statusCounts[outputNodeId]?.output_mismatch ?? 0,
    totalFailed: 0,
    totalIgnored: 0,
    totalPending: 0,
    totalOther: 0,
  };
  // Failed, pending, ignored, and cancelled are each recorded at exactly one node per decision.
  for (const c of Object.values(statusCounts)) {
    totals.totalFailed += c.failed;
    totals.totalIgnored += c.ignored;
    totals.totalPending += c.pending;
    totals.totalOther += c.other + c.cancelled;
  }
  return totals;
};

export const computeRunningTotal = (
  data: MetricsNodeStatusCountsResponse,
  outputNodeId: string,
): number => {
  if (Object.keys(data.status_counts).length === 0) return 0;
  const {
    totalSuccess,
    totalFailed,
    totalIgnored,
    totalPending,
    totalOther,
    totalOutputMismatch,
  } = aggregateStatusCounts(data.status_counts, outputNodeId);
  return (
    totalFailed +
    totalIgnored +
    totalPending +
    totalOther +
    totalSuccess +
    totalOutputMismatch
  );
};
